/**
 * Click/hover-to-load YouTube facade for product cards.
 * No iframe (and no YouTube JS/cookies) until a user gesture on the card.
 */
(function () {
  function activate(facade) {
    if (!facade || facade.getAttribute('data-loaded') === '1') return;
    var src = facade.getAttribute('data-src');
    if (!src) return;

    facade.setAttribute('data-loaded', '1');

    var iframe = document.createElement('iframe');
    iframe.className = 'js-youtube';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
    );
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');
    iframe.setAttribute('loading', 'lazy');
    iframe.title = facade.getAttribute('data-title') || 'YouTube video';
    iframe.src = src;

    facade.replaceChildren(iframe);
  }

  function bindFacade(facade) {
    if (!facade || facade.getAttribute('data-bound') === '1') return;
    facade.setAttribute('data-bound', '1');

    var host =
      facade.closest('.product-image') ||
      facade.closest('.product-media-wrap') ||
      facade.closest('.product-card') ||
      facade;

    var load = function () {
      activate(facade);
    };

    host.addEventListener('pointerenter', load, { once: true, passive: true });
    host.addEventListener('focusin', load, { once: true });
    host.addEventListener('touchstart', load, { once: true, passive: true });
  }

  function bindRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-youtube-facade]').forEach(bindFacade);
  }

  function boot() {
    bindRoot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindRoot(event.target);
  });
})();
